/* ============================================================
   NEWSLETTER POPUP LOGIC
   Kurulum: Bu dosyayı temanızdaki "Assets" klasörüne yükleyin
   (Edit code > Assets > Add a new asset > dosyayı seçin)
   ============================================================ */

(function () {
  var STORAGE_KEY_SUBSCRIBED = 'newsletterPopupSubscribed';
  var STORAGE_KEY_CLOSED_SESSION = 'newsletterPopupClosedSession';

  document.addEventListener('DOMContentLoaded', function () {
    var popups = document.querySelectorAll('.newsletter-popup');

    popups.forEach(function (popup) {
      var alreadySubscribed = localStorage.getItem(STORAGE_KEY_SUBSCRIBED) === 'true';
      var closedThisSession = sessionStorage.getItem(STORAGE_KEY_CLOSED_SESSION) === 'true';
      var successEl = popup.querySelector('.newsletter-popup__success');
      var justSubscribed = !!successEl;

      // Daha önce abone olunduysa bir daha hiç gösterme.
      if (alreadySubscribed && !justSubscribed) {
        return;
      }

      // Bu oturumda kapatıldıysa (ve abone olunmadıysa) tekrar gösterme.
      if (closedThisSession && !justSubscribed) {
        return;
      }

      var showPopup = function () {
        popup.classList.add('is-visible');
      };

      if (justSubscribed) {
        // Native form submit sonrası sayfa yeniden yüklendi, başarı mesajını göster
        // ve bir daha çıkmaması için kalıcı olarak işaretle.
        localStorage.setItem(STORAGE_KEY_SUBSCRIBED, 'true');
        showPopup();
      } else {
        var delay = parseInt(popup.getAttribute('data-delay'), 10) || 0;
        window.setTimeout(showPopup, delay);
      }

      var closeBtn = popup.querySelector('.newsletter-popup__close');
      var overlay = popup.querySelector('.newsletter-popup__overlay');

      var closePopup = function () {
        popup.classList.remove('is-visible');
        sessionStorage.setItem(STORAGE_KEY_CLOSED_SESSION, 'true');
      };

      if (closeBtn) {
        closeBtn.addEventListener('click', closePopup);
      }

      if (overlay) {
        overlay.addEventListener('click', closePopup);
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && popup.classList.contains('is-visible')) {
          closePopup();
        }
      });
    });
  });
})();
